import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Button, Container, Form, Tabs, Table, Tab, Badge } from "react-bootstrap";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import ShowEntries from "../commoncomponents/ShowEntries";
import Search from "../commoncomponents/Search";
import { encodeQueryData } from "../../api/apiClient";
import Paginations from "../commoncomponents/pagination";
import ShowingResults from "../commoncomponents/showingResults";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from '../../reducers/actions';
import { connect } from 'react-redux';
import { utcToLocalOrFallback } from '../../utils/dateConvert'

class GroupDetails extends Component {

  constructor(props) {
    super(props);
    this.state = {
      groupDetails: [],
      assetDetails: [],
      usersDetails: [],
      assetsPageCount: 0,
      usersPageCount: 0,
      assetsTotalCount: 0,
      usersTotalCount: 0,
      //states for showing entries and total entries in page on Assets
      totalEntryA: 0,
      entryStartA: "1",
      entryEndA: "10",
      totalFilterA: false,
      totalEntryFilterA: "",
      filterMessageA: false,
      //states for showing entries and total entries in page on Users
      totalEntryU: 0,
      entryStartU: "1",
      entryEndU: "10",
      totalFilterU: false,
      totalEntryFilterU: "",
      filterMessageU: false,
      //user table sort
      sortStringUser: 'name',
      sortDirectionUser: 'asc',
      //Asser table sort
      sortString: 'name',
      sortDirection: 'asc',
    }
    this.sortStringName = 'name';
    this.sortDirection = 'asc';
    this.sortStringNameUser = 'name';
    this.sortDirectionUser = 'asc';
    this.checkedAssets = [];
    this.assetsPageSize = "10";
    this.assetsSearchText = "";
    this.assetsPageKey = "1";
    this.usersPageSize = "10";
    this.usersSearchText = "";
    this.usersPageKey = "1";
  }
  async componentDidMount() {
    let groupId = this.props.match.params.id;
    this.props.setLoadingPageAction(true);

    try {
      const groupDetail = await axios.get(
        `${apiHost}/api/Group/SelectGroup/${groupId}`,

        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      );

      this.setState({ groupDetails: groupDetail.data });
      console.log("group id", groupDetail.data);
      this.props.setLoadingPageAction(false);

    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`)

      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
    let query = encodeQueryData(this.setUserQueryObject());
    let UrlAll = `${apiHost}/api/Group/AssetsByGroupForDetails/${groupId}?${query}`;
    this.postAssets(UrlAll);
    let UrlUsers = `${apiHost}/api/Group/UsersByGroupForDetails/${groupId}?${query}`;
    this.postUsers(UrlUsers);
  }

  //Sort functionality of Assets table starts here

  handleSortString = (name) => {
    this.setState({
      sortString: name,
      sortDirection: 'asc'
    });
    this.sortStringName = name;
    this.sortDirection = 'asc';
    this.callback(name, this.sortDirection);
  }
  handleSortDirection = () => {
    if (this.state.sortDirection == 'asc') {
      this.setState({
        sortDirection: 'des'
      })
      this.sortDirection = 'des';
    } else {
      this.setState({
        sortDirection: 'asc'
      })
      this.sortDirection = "asc";
    }
    this.callback(this.sortStringName, this.sortDirection);
  }

  callback = (name, order) => {
    this.handleSort(name, order);
  }

  handleSort = (name, order) => {
    let groupId = this.props.match.params.id;
    this.sortString = name;
    this.sortDirection = order;
    console.log("name", this.sortString, "order", this.sortDirection);
    let query = encodeQueryData(this.setAssetsQueryObject());
    let urlAll = `${apiHost}/api/Group/AssetsByGroup/${groupId}?${query}`;

    this.postAssets(urlAll);

  }
  //Sort functionality of Assets table ends here
  //Sort functionality of user table starts here

  handleSortStringUser = (name) => {
    this.setState({
      sortStringUser: name,
      sortDirectionUser: 'asc'
    });
    this.sortStringNameUser = name;
    this.sortDirectionUser = 'asc';
    this.callbackUser(name, this.sortDirectionUser);
  }
  handleSortDirectionUser = () => {
    if (this.state.sortDirectionUser == 'asc') {
      this.setState({
        sortDirectionUser: 'des'
      })
      this.sortDirectionUser = 'des';
    } else {
      this.setState({
        sortDirectionUser: 'asc'
      })
      this.sortDirectionUser = "asc";
    }
    this.callbackUser(this.sortStringNameUser, this.sortDirectionUser);
  }

  callbackUser = (name, order) => {
    this.sortFunctionUser(name, order);
  }
  sortFunctionUser = (name, order) => {
    // var checkBoxes = document.getElementsByClassName("tr-usercheckBox");
    // for (var i in checkBoxes) {
    //   if (checkBoxes[i].checked) {
    //     checkBoxes[i].checked = false;
    //     var tr = document.getElementById(`truser-${checkBoxes[i].value}`);
    //     if (tr.bgColor == "#999999") {
    //       tr.bgColor = "#FFFFFF";
    //       tr.color = "#212529";
    //     } else {
    //       tr.bgColor = "#999999";
    //       tr.color = "#FFFFFF";
    //     }
    //   }
    // }
    let groupId = this.props.match.params.id;
    this.sortStringUser = name;
    this.sortDirectionUser = order;
    console.log("name", this.sortStringUser, "order", this.sortDirectionUser);
    let query = encodeQueryData(this.setUserQueryObject());

    console.log("query user noject", query)
    let urlAll = `${apiHost}/api/Group/UsersByGroup/${groupId}?${query}`;
    this.postUsers(urlAll);

  }
  //Sort functionality of user table ends here




  handleAssetSearch = inputSearch => {
    //filtered by message on showing results
    if (inputSearch == "") {
      this.setState({ filterMessageA: false });
    } else {
      this.setState({ filterMessageA: true });
    }
    let groupId = this.props.match.params.id;
    this.assetsSearchText = inputSearch;
    let query = encodeQueryData(this.setAssetsQueryObject());
    let urlAll = `${apiHost}/api/Group/AssetsByGroupForDetails/${groupId}?${query}`;
    this.postAssets(urlAll);
  };

  handleAssetShowEntries = inputShowEntries => {
    let groupId = this.props.match.params.id;
    console.log(inputShowEntries);
    this.assetsPageSize = inputShowEntries;
    let query = encodeQueryData(this.setAssetsQueryObject());
    let urlAll = `${apiHost}/api/Group/AssetsByGroupForDetails/${groupId}?${query}`;
    this.postAssets(urlAll);
  };

  setAssetsQueryObject = () => {
    let data = {};
    data.SearchString = this.assetsSearchText;
    data.PageSize = this.assetsPageSize;
    data.PageNumber = this.assetsPageKey;
    data.SortDirection = this.sortDirection;
    data.SortString = this.sortString;
    return data;
  };
  handleAssetsPagination = page => {
    let groupId = this.props.match.params.id;
    this.assetsPageKey = page;
    let query = encodeQueryData(this.setAssetsQueryObject());
    let urlAll = `${apiHost}/api/Group/AssetsByGroupForDetails/${groupId}?${query}`;
    this.postAssets(urlAll);
  };

  handleUserSearch = inputSearch => {
    //filtered by message on showing results
    if (inputSearch == "") {
      this.setState({ filterMessageU: false });
    } else {
      this.setState({ filterMessageU: true });
    }
    let groupId = this.props.match.params.id;
    this.usersSearchText = inputSearch;
    let query = encodeQueryData(this.setUserQueryObject());
    let urlAll = `${apiHost}/api/Group/UsersByGroupForDetails/${groupId}?${query}`;
    this.postUsers(urlAll);
  };

  handleUserShowEntries = inputShowEntries => {
    let groupId = this.props.match.params.id;
    console.log(inputShowEntries);
    this.usersPageSize = inputShowEntries;
    let query = encodeQueryData(this.setUserQueryObject());
    let urlAll = `${apiHost}/api/Group/UsersByGroupForDetails/${groupId}?${query}`;
    this.postUsers(urlAll);
  };

  setUserQueryObject = () => {
    let data = {};
    data.SearchString = this.usersSearchText;
    data.PageSize = this.usersPageSize;
    data.PageNumber = this.usersPageKey;
    data.SortDirection = this.sortDirectionUser;
    data.SortString = this.sortStringUser;
    return data;
  };
  handleUsersPagination = page => {
    let groupId = this.props.match.params.id;

    this.usersPageKey = page;
    let query = encodeQueryData(this.setUserQueryObject());
    let urlAll = `${apiHost}/api/Group/UsersByGroupForDetails/${groupId}?${query}`;

    this.postUsers(urlAll);
  };
  handleShowAssetsResults = response => {
    // function for showing entries and total entries in page

    this.setState({
      totalEntryA: JSON.parse(response.headers.pagination).totalItems
    });
    if (!this.state.totalFilterA) {
      this.setState({
        totalEntryFilterA: JSON.parse(response.headers.pagination).totalItems,
        totalFilterA: true
      });
    }
    this.setState({
      entryStartA:
        (parseInt(this.assetsPageKey) - 1) * parseInt(this.assetsPageSize) + 1
    });
    if (
      JSON.parse(response.headers.pagination).totalItems <
      parseInt(this.state.entryEndA)
    ) {
      this.setState({
        entryEndA: JSON.parse(response.headers.pagination).totalItems
      });
    } else {
      let value =
        parseInt(JSON.parse(response.headers.pagination).currentPage) *
        parseInt(this.assetsPageSize);
      this.setState({ entryEndA: value });
    }
    if (
      this.state.entryEndA >
      parseInt(JSON.parse(response.headers.pagination).totalItems)
    ) {
      this.setState({
        entryEndA: JSON.parse(response.headers.pagination).totalItems
      });
    }
    if (this.state.assetDetails == "") {
      this.setState({ entryStartA: "0", entryEndA: "0", totalEntryA: "0" });
    }
  };

  handleShowUsersResults = response => {
    // function for showing entries and total entries in page

    this.setState({
      totalEntryU: JSON.parse(response.headers.pagination).totalItems
    });
    if (!this.state.totalFilterU) {
      this.setState({
        totalEntryFilterU: JSON.parse(response.headers.pagination).totalItems,
        totalFilterU: true
      });
    }
    this.setState({
      entryStartU:
        (parseInt(this.usersPageKey) - 1) * parseInt(this.usersPageSize) + 1
    });
    if (
      JSON.parse(response.headers.pagination).totalItems <
      parseInt(this.state.entryEndU)
    ) {
      this.setState({
        entryEndU: JSON.parse(response.headers.pagination).totalItems
      });
    } else {
      let value =
        parseInt(JSON.parse(response.headers.pagination).currentPage) *
        parseInt(this.usersPageSize);
      this.setState({ entryEndU: value });
    }
    if (
      this.state.entryEndU >
      parseInt(JSON.parse(response.headers.pagination).totalItems)
    ) {
      this.setState({
        entryEndU: JSON.parse(response.headers.pagination).totalItems
      });
    }
    if (this.state.usersDetails == "") {
      this.setState({ entryStartU: "0", entryEndU: "0", totalEntryU: "0" });
    }
  };


  postAssets = async url => {
    this.props.setLoadingPageAction(true);

    try {
      let assetDetails = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      );
      console.log("assetDetails", assetDetails);
      this.setState({
        assetDetails: assetDetails.data.paggedlist,
        assetsPageCount: JSON.parse(assetDetails.headers.pagination).totalPages,
        assetsTotalCount: assetDetails.data.includedelementsCount,
      });
      this.handleShowAssetsResults(assetDetails);

      this.props.setLoadingPageAction(false);

    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`)

      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  postUsers = async url => {
    this.props.setLoadingPageAction(true);

    try {
      let usersDetails = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      );
      console.log("usersDetails", usersDetails);
      this.setState({
        usersDetails: usersDetails.data.paggedlist,
        usersPageCount: JSON.parse(usersDetails.headers.pagination).totalPages,
        usersTotalCount: usersDetails.data.includedelementsCount
      });
      this.handleShowUsersResults(usersDetails);

      this.props.setLoadingPageAction(false);

    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`)

      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleSubmit() {
    this.props.history.push(`/editGroup/${this.state.groupDetails.id}`);
  }
  handleCheck = (e, assets) => {
    var CheckBox = document.getElementById(e.target.id);
    if (CheckBox.checked == true) {
      this.checkedAssets.push(e.target.value);
    } else {
      const index = this.checkedAssets.indexOf(e.target.value);

      this.checkedAssets.splice(index, 1);
    }
    console.log("checked assets array", this.checkedAssets);
  };
  render() {
    const { groupDetails } = this.state;
    const arr = [10, 25, 50, 100];

    return (
      <div>
        <React.Fragment>
          <Layout>

            <Helmet>
              <title>Group Details </title>

            </Helmet>
            <div className="contentBody">
              <div className="contentWrapper">
                <h2>Group Details</h2>
                <h6>{this.state.groupDetails.name}</h6>
                <hr></hr>

                <Tabs>
                  <Tab eventKey="details" title="Details">
                    <Container>
                      <div className="groupDetails">
                        <div className="individualDetail">
                          <p className="left"> Name</p>
                          <p className="right">{groupDetails.name} </p>
                        </div>
                        <div className="individualDetail">
                          <p className="left"> Description</p>
                          <p className="right"> {groupDetails.description} </p>
                        </div>
                        <div className="individualDetail">
                          <p className="left">Customer</p>
                          <p className="right">{groupDetails.customerName}</p>
                        </div>
                        <div className="individualDetail">
                          <p className="left"> Icon & Colour</p>
                          <p className="right">
                            <i
                              style={{ color: `${groupDetails.colour}` }}
                              className={`${groupDetails.icon}`}
                            ></i>{" "}
                          </p>
                        </div>
                        <div className="individualDetail">
                          <p className="left"> Menu Default</p>

                          <p className="right">
                            {" "}
                            {groupDetails.menuDefault == 0 ? (
                              <Form.Check type="checkbox" />
                            ) : (
                              <input type="checkbox" checked />
                            )}
                          </p>
                        </div>
                        <div className="individualDetail">
                          <p className="left"> Menu Sequence</p>
                          <p className="right"> {groupDetails.menuPriority}</p>
                        </div>
                        <div className="individualDetail">
                          <p className="left"> Status</p>
                          <p className="right">
                            {" "}
                            {groupDetails.status == 0 ? "Disabled" : "Active"}
                          </p>
                        </div>
                        {/* <div className="individualDetail">
                        <p className="left">External ID</p>
                        <p className="right"> {groupDetails.externalId}</p>
                      </div> */}
                        <div className="individualDetail">
                          <p className="left"> Created</p>
                          <p className="right">{utcToLocalOrFallback(groupDetails.dbCreated)} </p>
                        </div>
                        <div className="individualDetail">
                          <p className="left"> Updated</p>
                          <p className="right">{utcToLocalOrFallback(groupDetails.dbUpdated)} </p>
                        </div>
                      </div>
                    </Container>
                  </Tab>
                  <Tab eventKey="assets" title={<span>Assets  <Badge pill variant="secondary">{this.state.assetsTotalCount}</Badge> </span>}>
                    <div className="inline">
                      {" "}
                      <ShowEntries
                        data={arr}
                        showEntriesCallback={this.handleAssetShowEntries}
                      />
                      <Search searchCallback={this.handleAssetSearch}></Search>
                    </div>
                    <Table responsive striped>
                      <thead>
                        <tr>
                          <th>Name {this.state.sortString == 'name' ? <i onClick={this.handleSortDirection} className={`fa ${this.state.sortDirection == 'asc' ? "fa-sort-amount-asc" : "fa-sort-amount-desc"}`} /> : <i className="fa fa-exchange" onClick={() => { this.handleSortString("name") }} />}</th>
                          <th>Tag1 {this.state.sortString == 'tag1' ? <i onClick={this.handleSortDirection} className={`fa ${this.state.sortDirection == 'asc' ? "fa-sort-amount-asc" : "fa-sort-amount-desc"}`} /> : <i className="fa fa-exchange" onClick={() => { this.handleSortString("tag1") }} />}</th>
                          <th>Tag2 {this.state.sortString == 'tag2' ? <i onClick={this.handleSortDirection} className={`fa ${this.state.sortDirection == 'asc' ? "fa-sort-amount-asc" : "fa-sort-amount-desc"}`} /> : <i className="fa fa-exchange" onClick={() => { this.handleSortString("tag2") }} />}</th>
                          <th>Description </th>
                          <th>Status {this.state.sortString == 'status' ? <i onClick={this.handleSortDirection} className={`fa ${this.state.sortDirection == 'asc' ? "fa-sort-amount-asc" : "fa-sort-amount-desc"}`} /> : <i className="fa fa-exchange" onClick={() => { this.handleSortString("status") }} />}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.assetDetails.map((assets, index) => {
                          return (
                            assets.isMember && (
                              <tr>
                                <td>{assets.name}</td>
                                <td>{assets.tag1}</td>
                                <td>{assets.tag2}</td>
                                <td>{assets.description}</td>

                                <td>{assets.status}</td>
                              </tr>
                            )
                          );
                        })}
                      </tbody>
                    </Table>
                    <div className="paginationDetails">
                      <ShowingResults
                        currentEntryStart={this.state.entryStartA}
                        currentEntryEnd={this.state.entryEndA}
                        totalEntries={this.state.totalEntryA}
                        totalFilterEntries={this.state.totalEntryFilterA}
                        filterMessage={this.state.filterMessageA}
                      />
                      <Paginations
                        onPagination={this.handleAssetsPagination}
                        pageCount={this.state.assetsPageCount}
                        pageRange={5}
                      ></Paginations>
                    </div>

                  </Tab>
                  <Tab eventKey="members" title={<span>Members  <Badge pill variant="secondary">{this.state.usersTotalCount}</Badge> </span>}>
                    <div className="inline">
                      {" "}
                      <ShowEntries
                        data={arr}
                        showEntriesCallback={this.handleUserShowEntries}
                      />
                      <Search searchCallback={this.handleUserSearch}></Search>
                    </div>
                    <Table responsive striped>
                      <thead>
                        <tr>
                          <th>Name {this.state.sortStringUser == 'name' ? <i onClick={this.handleSortDirectionUser} className={`fa ${this.state.sortDirectionUser == 'asc' ? "fa-sort-amount-asc" : "fa-sort-amount-desc"}`} /> : <i className="fa fa-exchange" onClick={() => { this.handleSortStringUser("name") }} />} </th>
                          <th>Email {this.state.sortStringUser == 'email' ? <i onClick={this.handleSortDirectionUser} className={`fa ${this.state.sortDirectionUser == 'asc' ? "fa-sort-amount-asc" : "fa-sort-amount-desc"}`} /> : <i className="fa fa-exchange" onClick={() => { this.handleSortStringUser("email") }} />} </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.usersDetails.map((users, index) => {
                          return (
                            users.isExistMember && (
                              <tr>
                                <td>{users.userName}</td>
                                <td>{users.email}</td>
                              </tr>
                            )
                          );
                        })}
                      </tbody>
                    </Table>
                    <div className="paginationDetails">
                      <ShowingResults
                        currentEntryStart={this.state.entryStartU}
                        currentEntryEnd={this.state.entryEndU}
                        totalEntries={this.state.totalEntryU}
                        totalFilterEntries={this.state.totalEntryFilterU}
                        filterMessage={this.state.filterMessageU}
                      />
                      <Paginations
                        onPagination={this.handleUsersPagination}
                        pageCount={this.state.usersPageCount}
                        pageRange={5}
                      ></Paginations>
                    </div>
                  </Tab>
                </Tabs>

                <div className="footer-menu">
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    onClick={() => {
                      // this.props.history.push("/groups");
                      this.props.history.goBack();
                    }}
                  >
                    Back to List
                  </Button>
                  &nbsp;
                  <Button
                    size="sm"
                    variant="primary"
                    onClick={this.handleSubmit.bind(this)}
                  >
                    Edit
                  </Button>
                </div>
              </div>
            </div>
          </Layout>
        </React.Fragment>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({

  loading: state.loading

})
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage


}

export default connect(mapStateToProps, mapDispatchToProps)(GroupDetails);
